import { isValidPhoneNumber } from 'react-phone-number-input';
import i18n from 'i18next';
import moment from 'moment';
import { FormInstance } from 'antd';

import { Rule } from 'models/form';

const { t } = i18n;

const MIN_AMOUNT_WITHDRAWAL = 1;

export const REQUIRED = { required: true, whitespace: true, message: () => t('errorEmptyText') };
export const REQUIRED_SELECT = {
	required: true,
	message: () => t('errorEmptyText'),
};

export const REQUIRED_CHECKBOX = {
	required: true,
	transform: (value: any) => value || undefined,
	type: 'boolean',
	message: '',
};

export const LT_PID_NUMBER = {
	required: true,
	type: 'string',
	pattern: new RegExp(/^\d+$/),
	min: 11,
	max: 11,
	message: 'Asmens kodas turi būti sudarytas iš 11 skaičių',
};
export const REQUIRED_ANSWER =
	(name: string) =>
	({ getFieldValue }: FormInstance) => ({
		validator() {
			if (getFieldValue(name)?.length > 0) {
				return Promise.resolve();
			}

			return Promise.reject('');
		},
	});

export const EMAIL = { type: 'email', message: () => t('invalidEmailText') };

export const PASSWORD = {
	pattern: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/g),
	message: () => t('invalidPasswordText'),
};

export const MIN_LENGTH =
	(name: string, length: number) =>
	({ getFieldValue }: FormInstance) => ({
		validator() {
			if (!getFieldValue(name) || getFieldValue(name)?.length >= length) {
				return Promise.resolve();
			}

			return Promise.reject(t('errorMinLengthText', { length }));
		},
	});

export const LOWERCASE = {
	pattern: new RegExp(/[a-z]/g),
	message: () => t('passwordMessageOneText'),
};

export const UPPERCASE = {
	pattern: new RegExp(/[A-Z]/g),
	message: () => t('passwordMessageThreeText'),
};

export const NUMERIC = {
	pattern: new RegExp(/[0-9]/g),
	message: () => t('passwordMessageFourText'),
};

export const COMPARE_PASSWORDS =
	(name: string) =>
	({ getFieldValue }: FormInstance) => ({
		validator(rule: Rule, value: string) {
			if (!value || getFieldValue(name) === value) {
				return Promise.resolve();
			}
			return Promise.reject(t('errorPasswordsNotMatchText'));
		},
	});

export const MAX_LENGTH =
	(name: string, length: number) =>
	({ getFieldValue }: FormInstance) => ({
		validator() {
			if (!getFieldValue(name) || getFieldValue(name)?.length <= length) {
				return Promise.resolve();
			}

			return Promise.reject(t('errorMaxLengthText', { length }));
		},
	});

export const PHONE =
	(name: string) =>
	({ getFieldValue }: FormInstance) => ({
		validator() {
			const phone = getFieldValue(name);
			if (!getFieldValue(name) || isValidPhoneNumber(phone)) {
				return Promise.resolve();
			}

			return Promise.reject(t('errorPhoneFormatText'));
		},
	});

export const LOW_BALANCE =
	(availableMoney: number) =>
	({ getFieldValue }: FormInstance) => ({
		validator(rule: Rule, value: string) {
			if (!value || +getFieldValue('amount') <= availableMoney) {
				return Promise.resolve();
			}
			return Promise.reject(t('errorLowInvestorBalanceText'));
		},
	});

export const VERY_BIG_AMOUNT =
	(availableAmount: number) =>
	({ getFieldValue }: FormInstance) => ({
		validator(rule: Rule, value: string) {
			if (!value || +getFieldValue('amount') <= availableAmount) {
				return Promise.resolve();
			}
			return Promise.reject(t('errorVeryBigAmountText'));
		},
	});

export const NO_LESS_THAN =
	() =>
	({ getFieldValue }: FormInstance) => ({
		validator(rule: Rule, value: string) {
			if (!value || +getFieldValue('amount') >= MIN_AMOUNT_WITHDRAWAL) {
				return Promise.resolve();
			}
			return Promise.reject(t('errorAmountWithdrawalLessText'));
		},
	});

export const INVALID_DATE = () => () => ({
	validator(rule: Rule, value: string) {
		if (moment(value).isValid()) {
			return Promise.resolve();
		}
		return Promise.reject(t('errorInvalidDateText'));
	},
});
